export default {"src":"/_next/static/media/clock-icon.6c9a7127.svg","height":512,"width":512};